<div
  bsModal
  #reportBrokenLinkModal="bs-modal"
  [config]="{
    show: false,
    keyboard: !modalControl.isSaving,
    ignoreBackdropClick: modalControl.isSaving
  }"
  [rlTrapFocus]="focusTrapConfig"
  class="c-modal modal fade qa-report-broken-link-modal"
  tabindex="-1"
  role="alertdialog"
  aria-labelledby="report-broken-link-modal-heading"
  aria-describedby="report-broken-link-modal-link-item-title"
  aria-hidden="true"
  (onHidden)="onHidden($event)"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <span class="fa-stack fa-5x" aria-hidden="true">
        <i class="fas fa-circle fa-stack-2x icon-bg-default"></i>
        <i class="fal fa-link fa-stack-1x t-brand-color"></i>
      </span>

      <h2
        id="report-broken-link-modal-heading"
        i18n="@@reportBrokenLinkModal-heading-reportBrokenLink"
        class="alpha"
      >
        Report broken link
      </h2>

      <p
        class="qa-report-broken-link__description"
        i18n="@@reportBrokenLinkModal-description"
      >
        Please help your library improve their user experience by submitting the
        broken link report.
      </p>

      <div
        *ngIf="state?.modalControl?.savingError"
        class="alert alert-danger qa-report-broken-link__error"
        role="alert"
      >
        <strong i18n="@@reportBrokenLinkModal-status-error">Error!</strong>
        <ng-container i18n="@@reportBrokenLinkModal-status-errorPleaseRetry">
          There was an error reporting the broken link. Please try
          again.</ng-container
        >
      </div>

      <form [formGroup]="reportBrokenLinkDetailsForm" class="w-100">
        <div *ngIf="!userEmailAddress" class="form-group text-left">
          <label class="form-label" [for]="formEmailId">
            <ng-container i18n="@@reportBrokenLinkModal-email-label"
              >Email:
            </ng-container>
          </label>
          <div
            class="help-block"
            i18n="@@reportBrokenLinkModal-email-helpBlock"
          >
            Report with email will help your library troubleshoot faster.
          </div>
          <input
            class="form-control qa-email"
            type="email"
            name="email"
            [id]="formEmailId"
            formControlName="email"
            [attr.aria-invalid]="
              formEmail.dirty && formEmail.errors ? true : false
            "
            [attr.aria-describedby]="
              formEmail.dirty && formEmail.errors ? formEmailErrorsId : null
            "
            rlAutofocus
            autocomplete="email"
          />
          <span
            *ngIf="formEmail.dirty && formEmail.errors ? true : false"
            [id]="formEmailErrorsId"
            role="alert"
          >
            <span
              *ngIf="formEmail.errors.email"
              i18n="@@reportBrokenLink-email-validation-message"
              class="text-left text-danger qa-report-broken-link__validation-email"
            >
              Email address not valid.
            </span>

            <span
              *ngIf="formEmail.errors.maxlength"
              i18n="@@reportBrokenLink-email-validation-maxlength-message"
              class="text-left text-danger qa-report-broken-link__validation-email-maxlength"
            >
              Email address can not exceed
              {{ emailMaxLength }} characters. Currently there are
              {{ formEmail.errors.maxlength.actualLength }}.
            </span>
          </span>
        </div>

        <div class="form-group text-left">
          <label
            class="form-label"
            [for]="formDetailsId"
            i18n="@@reportBrokenLinkModal-details-label"
            >Details:</label
          >
          <textarea
            class="form-control qa-details"
            [id]="formDetailsId"
            name="details"
            rows="3"
            cols="70"
            formControlName="details"
            [attr.aria-invalid]="
              formDetails.dirty && formDetails.errors ? true : false
            "
            [attr.aria-describedby]="
              formDetails.dirty && formDetails.errors
                ? formDetailsErrorsId
                : null
            "
          >
          </textarea>
          <span
            *ngIf="formDetails.dirty && formDetails.errors ? true : false"
            [id]="formDetailsErrorsId"
            role="alert"
          >
            <span
              *ngIf="formDetails.errors.pattern"
              i18n="@@reportBrokenLink-details-whitespace-only"
              class="text-left text-danger qa-report-broken-link__validation-non-empty"
              >Please complete description or remove space.</span
            >
            <span
              *ngIf="formDetails.errors.maxlength"
              i18n="@@reportBrokenLink-details-maxlength"
              class="text-left text-danger qa-report-broken-link__validation-maxlength"
            >
              Details can not exceed
              {{ detailsMaxLength }} characters. Currently there are
              {{ formDetails.errors.maxlength.actualLength }}.
            </span>
          </span>
        </div>

        <div *ngIf="userEmailAddress" class="form-group text-left">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input qa-anonymous"
              [id]="formAnonymousId"
              name="anonymous"
              formControlName="anonymous"
            />
            <label
              class="form-check-label form-label"
              [for]="formAnonymousId"
              i18n="@@reportBrokenLinkModal-anonymous-label"
              >Send anonymous report</label
            >
          </div>
          <div
            class="help-block"
            i18n="@@reportBrokenLinkModal-anonymous-helpBlock"
          >
            Please be aware that this will limit your library's ability to
            diagnose issues or to contact you to discuss.
          </div>
        </div>
      </form>

      <div class="c-modal__footer">
        <button
          (click)="onCancel()"
          type="button"
          class="btn btn-default qa-report-broken-link__cancel-button"
          i18n="@@reportBrokenLinkModal-btn-cancel"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary qa-report-broken-link__report-button"
          (click)="onReportBrokenLink()"
          [disabled]="
            state.modalControl.isSaving || reportBrokenLinkDetailsForm.invalid
          "
        >
          <span
            *ngIf="state?.modalControl?.isSaving"
            class="text-center qa-report-broken-link__saving"
            role="status"
          >
            <i
              class="fas fa-spinner-third fa-fw fa-spin"
              aria-hidden="true"
            ></i>
            <span class="sr-only" i18n="@@reportBrokenLinkModal-spinner-saving"
              >Saving...</span
            >
          </span>
          <ng-container i18n="@@reportBrokenLinkModal-btn-report">
            Report
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</div>
